import CommunicationHub from "../../../views/CommunicationHub";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import Details from "../../../components/CommunicationHub/Details";
import Create from "../../../components/CommunicationHub/Create";
import History from "../../../components/CommunicationHub/History";

const CommunicationHubRoutes = [
  {
    menuName: MenuNames.COMMUNICATION_HUB,
    path: "/communication-hub",
    component: CommunicationHub,
    exact: true,
  },
  {
    menuName: MenuNames.COMMUNICATION_HUB,
    path: "/communication-hub/new/:tag",
    component: Create,
    exact: true,
  },
  {
    menuName: MenuNames.COMMUNICATION_HUB,
    path: "/communication-hub/:tag/:id",
    component: Details,
    exact: true,
  },
  {
    menuName: MenuNames.COMMUNICATION_HUB,
    path: "/communication-hub/history/:tag/:id",
    component: History,
    exact: true,
  },
];
export default CommunicationHubRoutes;
